import React, { useEffect, useState } from "react";
import AdminLTE, {
  Sidebar,
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Label,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import "react-phone-input-2/lib/style.css";
import TimeInput from "react-time-picker-input";
import { diasOptions } from "../utils/utils";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const { Select2, Date, DateTime, Text } = Inputs;

function AddPromo({ history, match }) {
  const dispatch = useDispatch();

  const modelAddPromo = useSelector((state) => state.addPromo);
  const modelLocal = useSelector((state) => state.localById);

  const [local, setLocal] = useState(null);
  const [nombre, setNombre] = useState("");
  const [precio, setPrecio] = useState(0);
  const [localId, setLocalId] = useState(
    match.params.localId ? match.params.localId : null
  );
  const [inicio, setInicio] = useState(null);
  const [fin, setFin] = useState(null);
  const [servicioId, setServicioId] = useState(null);
  const [servicioNombre, setServicioNombre] = useState(null);
  const [serviciosPadreOptions, setServiciosPadreOptions] = useState([]);
  const [serviciosOptions, setServiciosOptions] = useState([]);
  const [servicio, setServicio] = useState(null);
  const [servicioPadre, setServicioPadre] = useState(null);

  const onChange = (dates) => {
    const [start, end] = dates;
   
    setInicio(start);
    setFin(end);
  };

  useEffect(() => {
    dispatch(controller.localByIdThunk(match.params.localId));
  }, []);
  useEffect(() => {
    const data = modelAddPromo?.data?.data;
    const error = modelAddPromo?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckAddPromo.actions.clear());
    }
    if (data) {
      history.goBack();
      dispatch(controller.duckAddPromo.actions.clear());
    }
  }, [modelAddPromo]);

  useEffect(() => {
    const data = modelLocal?.data?.data;
    const error = modelLocal?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckLocalById.actions.clear());
    }
    if (data && data.data) {
  
      setLocal(data.data);

      const subcategoriaOptions = data.data.subCategorias.map((row) => {
        if (row.estado === "ACTIVO") {
          return {
            label: row.nombre,
            value: row.id,
          };
        }
      });
      setServiciosPadreOptions(subcategoriaOptions);
      dispatch(controller.duckLocalById.actions.clear());
    }
  }, [modelLocal]);

  useEffect(() => {
    if (servicioPadre) {
      const hijos = local.servicios.filter(
        (elem) => elem.subCategoriaId === servicioPadre
      );
      const servicioOpciones = hijos.map((row) => {
        if (row.estado === "ACTIVO") {
          return {
            label: row.nombre,
            value: row.id,
            ...row,
          };
        }
      });
      setServiciosOptions(servicioOpciones);
      setServicio(null);
    }
  }, [servicioPadre]);

  function submit() {
  
    if (!nombre || !inicio || !fin) {
      alert("Por favor complete todos los campos");
      return;
    }

    if (!localId) {
      alert("No se ha podido obtener el ID del local");
      return;
    }

    const servicioSelected = local.servicios.filter((item)=>item.id===servicio);
    if (servicioSelected.length===0) {
      alert("Servicio no encontrado");
      return;
    }
   
    let data = {
      nombre,
      precio,
      inicio: moment(inicio).format("YYYY-MM-DD"),
      fin:  moment(fin).format("YYYY-MM-DD"),
      servicioId: servicio,
      localId,
      servicioNombre: servicioSelected[0].nombre,
    };

    dispatch(controller.addPromoThunk(data));
  }

  return (
    <Content title="Nueva promo" browserTitle="Nueva promo" show={false}>
      <Row>
        <Col md="4" mdOffset="4">
          <Box
            title="Nueva promo"
            footer={
              <>
                <Button text="Cancelar" onClick={() => history.goBack()} />

                <Button
                  type="primary"
                  text="Guardar"
                  pullRight={true}
                  disabled={modelAddPromo.loading}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <SelectInput
              value={servicioPadre}
              setValue={setServicioPadre}
              label="Subcategoria"
              options={serviciosPadreOptions}
            />

            <SelectInput
              value={servicio}
              setValue={setServicio}
              label="Servicio"
              options={serviciosOptions}
            />
            <Text
              labelPosition="above"
              size="sm"
              label="Nombre"
              value={nombre}
              onChange={(evt) => setNombre(evt.target.value)}
            />
            <Text
              labelPosition="above"
              size="sm"
              inputType="number"
              label="Precio"
              value={precio}
              onChange={(evt) => setPrecio(evt.target.value)}
            />

            <label>Rango (dd/mm/yyyy)</label>
            <DatePicker
              // dateFormat="dd/MM/yyyy"
              customInput={<input type="text" className="form-control" />}
              selected={inicio}
              onChange={onChange}
              startDate={inicio}
              endDate={fin}
              selectsRange
              // inline
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default AddPromo;
